<template>
  <app-base-main headFixed v-loading="pageLoading" :baseStyle="{ background: 'none'}">
    <template #base-content>
      <app-left-right>
        <template #left>
          <div class="right-market">{{ publicObj.SB.market.name }}:{{ publicObj.SB.market.countryCode }}</div>
          <div class="left-content">
            <div class="left-cell" v-for="(item, index) in leftSign" :key="item.index"  @click="anchorRoll(`#id${item.index}`)" :class="{'active': item.index == leftIndex, 'guide-line': item.index < leftIndex}">
              <div class="cell-index" v-if="item.index == leftIndex || !item.complete">{{ index + 1 }}</div>
              <div class="cell-index cell-complete" v-else><i class="el-icon-check"></i></div>
              <div class="cell-title">{{ item.title }}</div>
            </div>
          </div>
        </template>
        <template #right>
          <div class="right-content">
            <div class="right-scroll" ref="rightContent" @scroll="rightContentScroll">
              <div class="campaignName">{{ detailsData.campaignName }}</div>
              <add-cell cellTitle="基础信息" id="id1">
                <AddBase />
              </add-cell>
              <add-cell cellTitle="广告格式" id="id2" style="padding-bottom: 50px">
                <AddAdvertisingFormat />
              </add-cell>
              <add-cell cellTitle="创意" id="id3">
                <AddOriginality />
              </add-cell>
            </div>
          </div>
        </template>
      </app-left-right>
    </template>
  </app-base-main>
</template>

<script>
import AddCell from 'modules/ad/sb/ad-add/components/add-cell.vue'
import AddBase from './components/add-base'
import AddAdvertisingFormat from './components/add-advertising-format'
import AddOriginality from './components/add-originality'
import { getMarket } from "@/api/common";
import { campaignInfo } from "@/api/ad";

export default {
  name: "app-sb-add",
  components: {AddCell, AddBase, AddAdvertisingFormat, AddOriginality},
  async created() {
    this.publicObj.SB.marketId = this.$route.query.marketId
    this.pageLoading = true
    this.getMarket(this.publicObj.SB.marketId)
    await this.campaignInfo()
    this.pageLoading = false
  },
  async activated() {
    this.pageLoading = true
    this.publicObj.SB.marketId = this.$route.query.marketId
    this.getMarket(this.publicObj.SB.marketId)
    await this.campaignInfo()
    this.pageLoading = false
    this.$nextTick(() => {
      this.$refs.rightContent.scrollTop = this.rightScrollTop
    })
  },
  mounted() {},
  data() {
    return {
      publicObj: {
        SB: {
          isAdsAuth: false, // 站点是否授权广告
          isBrand: -1, // 站点是否有品牌 0：正在校验 1：无品牌 2：有品牌
          marketId: null,
          market: {},
          currencySymbol: null,
          rootMountEl: null,
          portfolios: [],
          campaign: null,
          group: null,
          campaignDate: null,
          groupDate: null
        }
      },
      rightScrollTop: 0,
      pageLoading: false,
      leftIndex: "1", // 当前位置索引
      detailsData: {},
      PublicData: {// 公共数据
        marketId: null,
      }, 
      forms: {
        leftIndex: "1", // [前端自用展示]
        draft: 0, // 草稿标志（0：草稿；1：非草稿）
        marketId: null, // 站点id
        addBase: { // 1. 基础信息
          name: null, // 广告活动名称
          budget: null, // 活动预算
          budgetType: 1, // 0:lifetime：生命周期,1: daily：每日
          startDate: new Date(), // 活动开始时间（YYYY-MM-DD）
          endDate: null, // 活动结束时间（YYYY-MM-DD）
          brandEntityId: null, // 品牌id
          portfolioId: null, // 广告组合id
        },
        addAdvertisingFormat: { // 2. 广告格式
          adFormat: 0, // 0：productCollection ： 品牌广告商品集合广告,1：video ： 品牌广告视频广告	
          adFormatUrl: null, // 0: url 1: 商品
          landingPage: {
            asins: [],
            url: null
          },
        },
        creative: { // 3. 创意
          imgInfo: {}, //  [前端自用展示] 图片数据 编辑用
          videoInfo: { //  [前端自用展示] 视频数据 编辑用
            duration: 0,
            size: 0,
          },
          brandName: null, // 品牌名称（非视频广告必传）
          brandLogoAssetID: null, // 品牌logo asset id（非视频广告必传）
          brandLogoUrl: null, // 品牌logo url（非视频广告必传
          headline: null, // 标题（非视频广告必传）
          asins: [], // 商品asin码列表（非视频广告可最多3个，视频广告只能1个）
          asinsItem: [], // [前端自用展示] 商品asin码列表（非视频广告可最多3个，视频广告只能1个）
          videoMediaIds: [], // 视频媒体id（视频广告专有，最大一个）
        },
      },
      leftSign: [
        { title: "基础信息", index: "1", height: '500px', complete: true},
        { title: "广告格式", index: "2", height: '500px', complete: false},
        { title: "创意", index: "3", height: '500px', complete: false},
      ],
    }
  },
  provide () {
    return {
      getForms: () => this.forms,
      getPublicObj: () => this.publicObj, // 抛出公共对象
      getDetailsData: () => this.detailsData,
    }
  },
  computed: {},
  methods: {
    // 根据站点id获取基本信息
    async getMarket(marketId) {
      let market = await getMarket(marketId);
      this.publicObj.SB.market = market;
      this.publicObj.SB.currencySymbol = market.currencySymbol;
    },
    // 获取详情
    async campaignInfo(param = {}) {
      let params = {
        marketId: this.publicObj.SB.marketId,
        campaignId: this.$route.query.campaignId,
      }
      Object.assign(params, param)
      try {
        let { data } = await campaignInfo(params)
        this.formsMap(data)
      } catch (error) {
        console.log('zs', error);
      }
    },
    // 映射forms
    formsMap(data) {
      this.detailsData = data
      // 1. 基础信息
      this.forms.addBase.name = data.campaignName || null  // 广告活动名称
      this.forms.addBase.budget = data.budget || null  // 活动预算
      this.forms.addBase.budgetType = data.budgetType  // 0:lifetime：生命周期 1: daily：每日
      this.forms.addBase.startDate = data.startDate || new Date()  // 活动开始时间（YYYY-MM-DD）
      this.forms.addBase.endDate = data.endDate || null  // 活动结束时间（YYYY-MM-DD）
      this.forms.addBase.brandEntityId = data.brandEntityId || null  // 品牌id
      this.forms.addBase.portfolioId = data.portfolioId || null  // 广告组合id
      // 2. 广告格式
      this.forms.addAdvertisingFormat.adFormat =  data.adFormat || 0  // 0：productCollection ： 品牌广告商品集合广告 1：video ： 品牌广告视频广告	
      // 0: url 1: 商品
      if (data.landingPageVo.pageType != 'store') {
          this.forms.addAdvertisingFormat.adFormatUrl = 1
          this.forms.addAdvertisingFormat.landingPage.asins = data.landingPageVo.asins || [] 
          this.forms.addAdvertisingFormat.landingPage.asinsItem = data.landingPageVo.productVOS || [] 
      }else {
          this.forms.addAdvertisingFormat.adFormatUrl = 0
          this.forms.addAdvertisingFormat.landingPage.url = data.landingPageVo.url || null
      }
      // 3. 创意
      this.forms.creative.imgInfo = {} //  [前端自用展示] 图片数据 编辑用
      this.forms.creative.videoInfo.duration = null // [前端自用展示] 视频数据 编辑用
      this.forms.creative.videoInfo.size = null // [前端自用展示] 视频数据 编辑用
      this.forms.creative.videoInfo.publishedMediaUrl =  data.creativeVo.videoUrl // [前端自用展示] 视频数据 编辑用
      this.forms.creative.brandName = data.creativeVo.brandName || null // 品牌名称（非视频广告必传）
      this.forms.creative.brandLogoAssetID = data.creativeVo.brandLogoAssetID || null  // 品牌logo asset id（非视频广告必传）
      this.forms.creative.brandLogoUrl = data.creativeVo.brandLogoUrl || null  // 品牌logo url（非视频广告必传
      this.forms.creative.headline = data.creativeVo.headline || null   // 标题（非视频广告必传）
      this.forms.creative.asins = data.creativeVo.asins || [] // 商品asin码列表（非视频广告可最多3个，视频广告只能1个）
      this.forms.creative.asinsItem = data.creativeVo.productVOS || []// [前端自用展示] 商品asin码列表（非视频广告可最多3个，视频广告只能1个）
      this.forms.creative.videoMediaIds = data.creativeVo.videoMediaIds || [] // 视频媒体id（视频广告专有，最大一个）
      // 4. 投放类型
      setTimeout(() => {
        this.$nextTick(() => {
          if (this.$refs.AddLaunchType) {
            this.$refs.AddLaunchType.form.targetingType = data.targetingType || 0 // 投放类型
            this.$refs.AddLaunchType.form.bidOptimization = data.bidOptimizationDesc
            this.$refs.AddLaunchType.form.keywordPickerForm1.items = data.keywords || []
            this.$refs.AddLaunchType.form.keywordPickerForm2.items = (data.negativeKeywords || []).map(e => ({
              ...e,
              keyword: e.keywordText,
              matchTypeText: e.matchType === 0 ? "否定精准" : "否定词组"
            }))
            this.$refs.AddLaunchType.form.productTargetPickerForm.items = (data.targetsBeansVo || []).map(e => ({
              ...e,
              type: e.asin ? 'asin' : 'categoryPath',
              identity: e.asin ? `asin_${e.asin}` : `categoryPath_${e.categoryPath}`,
            }))
            this.$refs.AddLaunchType.form.autoTargetPickerForm.items = (data.negativeTargetings || []).map(e => ({
              ...e,
              id: e.brandId
            }))
          }
        })
      }, 300);
      // this.forms.addLaunchType.targetingType = data.targetingType || 0 // 投放类型
      // this.forms.addLaunchType.bidOptimization = data.bidOptimization || false // 竞价优化（设置成true后，亚马逊将自动优化竞价）
      // this.forms.addLaunchType.keywords = data.keywords || [] // 关键词列表
      // this.forms.addLaunchType.negativeKeywords = data.negativeKeywords || [] // 否定关键词列表
      // this.forms.addLaunchType.targets = data.targets || [] // 商品投放列表
      // this.forms.addLaunchType.negativeTargets = data.negativeTargets || [] // 否定商品投放列表
    },
    // 锚点滚动事件
    anchorRoll(id) {
      document.querySelector(id).scrollIntoView({
        behavior: "smooth",
        inline: "nearest",
      });
    },
    rightContentScroll(e) {
      this.rightScrollTop = e.srcElement.scrollTop
      // 到顶判断
      if (e.srcElement.scrollTop == 0) {
        return this.leftIndex = 1
      }
      // 到底判断
      if (e.srcElement.scrollTop + e.srcElement.offsetHeight ==  e.srcElement.scrollHeight) {
        return this.leftIndex = 3
      }
      let childNodesHeight = [...e.srcElement.childNodes].map( item =>  item.offsetHeight )
      // 高度位置判断
      for (let index = 0; index < this.leftSign.length; index++) {
        if (e.srcElement.scrollTop < this.addNum(childNodesHeight, index + 1)) {
          return this.leftIndex = this.leftSign[index].index
        }
      }
    },
    addNum(arr = [], num) {
      return arr.slice(0, num).reduce((total, item) => {
        return total + item
      }, 0) - 200
    },
  }
}
</script>

<style lang="scss" scoped>
  @import 'src/views/modules/ad/common/common.scss';
  /deep/.vxe-header--column {
    background: #fff;
    span {
      font-weight: 500 !important;
    }
  }
  /deep/.el-tabs__nav-wrap {
    padding: 0 12px;
  }
  @media screen and (max-width: 1400px) {
      /deep/ .base-content{
        padding: 0 16px !important;
      }
      /deep/.left-container {
        max-width: 120px !important;
        min-width: 120px !important;
        .left-content {
          padding: 25px 0 0 10px;
        }
        .right-market {
          padding: 10px;
        }
      }
      /deep/.right-container {
        // width: calc(100vw - 168px) !important;
        // width: calc(100vw - 168px) !important;
        .AddLaunchType {
          .gj-picker {
            width: 1090px !important;
          }
        }
      }
      /deep/.add-cell {
        margin-left: 10px !important;
        // padding-right: 16px;
      }
      /deep/ .right-content{
        // padding-right: 16px;
      }
  }
  .campaignName {
    font-size: 16px;
    color: #333333;
    font-weight: 600;
    padding: 25px 25px 10px;
  }
  .right-market {
    padding: 0 25px 0;
    font-size: 14px;
    color: #000;
  }
  .ml18 {
    margin-left: 18px;
  }
  /deep/.container {
    height: 100%;
  }
  .right-market {
    border-bottom: 1px solid #EBEEF5;
    font-size: 12px;
    padding: 10px 0;
    padding-left: 32px;
    color: #666;
  }
  .left-content {
    padding: 25px 0 0 32px;
    font-size: 14px;
    -webkit-user-select: none;
    .left-cell {
      display: flex;
      align-items: center;
      padding-bottom: 47px;
      position: relative;
      cursor: pointer;
      .cell-index {
        width: 18px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-radius: 100%;
        border: 1px solid #999;
        &.cell-complete {
          font-size: 13px;
          font-weight: 900;
          color: #1F6EEF ;
          border: 1px solid #1F6EEF;
        }
      }
      .cell-title {
        padding-left: 10px;
      }
      &.active {
        color: #1F6EEF ;
        .cell-index {
          color: #fff ;
          border: 1px solid #1F6EEF;
          background: #1F6EEF;
        }
      }
      &::after {
        content: "";
        position: absolute;
        width: 1px;
        height: 35px;
        bottom: 6px;
        left: 9px;
        background: #E4E5E6;
      }
      &.guide-line {
        .cell-index {
          color: #1F6EEF ;
          border: 1px solid #1F6EEF;
        }
        &::after {
          background: #1F6EEF;
        }
      }
      &:last-child {
        &::after {
          height: 0;
        }
      }
    }
  }
  .right-content {
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    .right-scroll {
      flex: 1;
      overflow: auto;
    }
    /deep/.add-cell {
      // min-height: 500px;
    }
    .right-footer {
      height: 45px;
      box-shadow: 0px -2px 4px 0px rgba(0,0,0,0.1);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
